import { CommonModule, CurrencyPipe, DatePipe } from "@angular/common";
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  computed,
  OnDestroy,
  OnInit,
  signal,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import { GUID } from "@barthauer/abc/core";
import {
  DataService as CoreDataService,
  PersistMode,
  QueryColumn,
  QueryColumnSortOrder,
} from "@barthauer/abc/core/data";
import {
  AbcPopupComponent,
  Mode,
  _AbcButtonComponent,
  _AbcCheckBoxComponent,
  _AbcContextMenuComponent,
  _AbcGridColumn,
  _AbcGridComponent,
  _AbcProgressBarComponent,
  _AbcTooltipComponent,
} from "@barthauer/abc/ui-components";
import {
  DefaultIcons,
  Measure,
  Person,
  SubProject,
  ToastType,
} from "@barthauer/custom/xmt-models";
import {
  DxButtonModule,
  DxCheckBoxModule,
  DxContextMenuComponent,
  DxDataGridModule,
  DxDateBoxModule,
  DxFormModule,
  DxPopoverModule,
  DxScrollViewModule,
  DxTagBoxModule,
  DxTooltipModule,
} from "devextreme-angular";
import { Observable, of, Subscription } from "rxjs";
import { concatMap, finalize, first, switchMap } from "rxjs/operators";
import {
  ActionType,
  NotificationMessage,
  PermissionContext,
  ROLES,
} from "../../../models/enumeration-list.model";
import { AppService } from "../../../services/app.service";
import { DataService, ObjectKeys } from "../../../services/data.service";
import { NotificationService } from "../../../services/notification.service";
import { FavoritesService } from "../../../shared/favorite/favorites.service";
import { SharedModule } from "../../../shared/shared.module";
import { CreateMeasureComponent } from "../create-measure/create-measure.component";
import { MeasureService } from "../measure.service";
import { BasedRoleOPathService } from "../../../services/based-role-opath.service";
import { CheckPermissionDirective } from "../../../directives/check-permession-directive";
import { ScreenService } from "../../../services/screen.service";
import {
  CellPreparedEvent,
  Column,
  ToolbarPreparingEvent,
} from "devextreme/ui/data_grid";
import { SafeHtmlPipe } from "../../../shared/pipes/safeHtml.pipe";
import { EURO_SVG, ICON_SVG } from "../../../shared/assets/icons";
import { IRating } from "../measure-detail/measurre-evaluation/measure-evaluation.component";
import { MatIconModule } from "@angular/material/icon";
import {
  ResourceManagerService,
  ResourceSet,
} from "@barthauer/abc/core/resources";
import {
  AbcFilterComponent,
  DateFilterCondition,
  Filter,
  FilterType,
} from "@barthauer/abc/ui-components/abc-filter";
import { MeasureCardComponent } from "./measure-card/measure-card.component";
import { ValueChangedEvent } from "devextreme/ui/check_box";
import {
  RequestFormattedStatus,
  RequestStatus,
} from "../measure-detail/approval-request/enums";
import {
  ApprovalStatusConfig,
  ApprovalStatusConfigFactory,
} from "../approval-status.config";
import { ObjectTypeService } from "../../../services/object-type.service";
type TooltipType = "status" | "score";
export enum AbcCardViewType {
  Card,
  Grid,
}
@Component({
  selector: "ubt-geods-measure",
  templateUrl: "./measure-list.component.html",
  styleUrls: ["./measure-list.component.scss"],
  imports: [
    DxButtonModule,
    _AbcGridComponent,
    DxDataGridModule,
    AbcPopupComponent,
    CreateMeasureComponent,
    DxFormModule,
    DxCheckBoxModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxPopoverModule,
    DxScrollViewModule,
    DxTooltipModule,
    _AbcContextMenuComponent,
    SharedModule,
    CheckPermissionDirective,
    CurrencyPipe,
    SafeHtmlPipe,
    MatIconModule,
    _AbcButtonComponent,
    CommonModule,
    AbcFilterComponent,
    MeasureCardComponent,
    _AbcCheckBoxComponent,
  ],
})
export class MeasureListComponent implements OnInit, AfterViewInit, OnDestroy {
  @ViewChild("measureGrid") measureGrid: _AbcGridComponent;
  @ViewChild("confirmDeletePopup") confirmDeletePopup: AbcPopupComponent;
  @ViewChild("measureCreationForm") measureCreationForm: AbcPopupComponent;
  @ViewChild("myMeasuresButton") myMeasuresButton: _AbcButtonComponent;
  @ViewChild("contextMenu") contextMenu: DxContextMenuComponent;
  @ViewChild("measureCard") measureCard: MeasureCardComponent;
  rtlEnabled = false;
  protected res: ResourceSet;
  public measure: Measure = new Measure(null);
  public viewType: AbcCardViewType = AbcCardViewType.Grid;
  protected AbcCardViewType = AbcCardViewType;
  public selectionMode: Mode = Mode.None;
  public selectedMeasures = [];
  public measures: Measures[] = [];
  public measureColumns: QueryColumn[] = [];
  public measurePageTitle: string;
  public componentName = "measures";
  private currentProfileId: string;
  public fileDate: string;
  public ROLES = ROLES;
  public myMeasureTitle = computed(() =>
    this.dataService.res(
      this.myMeasure() ? "Ubt-Measure-All-Measures" : "Ubt-Measure-My-Measures",
    ),
  );
  public TooltipTarget: string;
  public ToolTipText: string = "";
  public isVisible: boolean = false;
  public Action = ActionType;
  public PermissionContext = PermissionContext;

  public contextMenuItems: any[] = [
    {
      text: this.dataService.res("Ubt-Measure-Edit-Measure"),
      onClick: (event) => {
        this.openMeasureDetails(event);
      },
    },
    {
      text: this.dataService.res("Ubt-Measure-Delete-Measure"),
      onClick: () => {
        this.openConfirmDialog();
      },
    },
    {
      text: this.dataService.res("Ubt-SubProject-Add-to-favorites"),
      onClick: (e) => {
        this.updateFavorite();
      },
    },
  ];
  private readonly VISIBLE_MEASURE_COLUMNS = [
    "Status",
    "Designation",
    "ParentId",
    "IdRefPersonResponsible",
    "EndDate",
    "CurrentGrade",
    "TotalScore",
  ];
  private readonly EXCLUDED_FIELDS = [
    "IdRefDepartment",
    "IdRefPersonConsultant",
    "InitialSituation",
    "Interval",
    "IntervalKind",
    "Kind",
    "OrgaTech",
    "OriginalTargetDate",
    "Summary",
    "PrevDect",
  ];
  private APPROVAL_STATUS_UI: Partial<
    Record<RequestFormattedStatus, ApprovalStatusConfig>
  >;

  public readonly iconSvg = ICON_SVG;
  public readonly euroSvg = EURO_SVG;
  private executorList: ILookup[] = [];
  public columnsHeader: Column[] = [
    {
      caption: this.dataService.res("Ubt-Measure-List-Status"),
      dataField: "Status",
      alignment: "center",
      minWidth: 50,
      width: 50,
      visibleIndex: 0,
      hidingPriority: 4,
    },
    {
      caption: this.dataService.res("Ubt-Measure-List-Designation"),
      dataField: "Designation",
      alignment: "center",
      visibleIndex: 1,
      hidingPriority: -1,
    },
    {
      caption: this.dataService.res("Ubt-Measure-List-IdRefPersonResponsible"),
      dataField: "IdRefPersonResponsible",
      alignment: "center",
      visibleIndex: 2,
      hidingPriority: 6,
    },
    {
      caption: this.dataService.res("Ubt-Measure-List-StartDate"),
      dataField: "StartDate",
      alignment: "center",
      dataType: "date",
      visibleIndex: 3,
      hidingPriority: 3,
    },
    {
      caption: this.dataService.res("Ubt-Measure-List-EndDate"),
      dataField: "EndDate",
      alignment: "center",
      dataType: "date",
      visibleIndex: 5,
      hidingPriority: 2,
    },
    {
      caption: this.dataService.res("Ubt-Measure-List-TotalScore"),
      dataField: "TotalScore",
      alignment: "center",
      visibleIndex: 6,
      hidingPriority: 7,
    },
    {
      caption: this.dataService.res("Ubt-Measure-List-CurrentGrade"),
      dataField: "CurrentGrade",
      alignment: "center",
      visibleIndex: 7,
      hidingPriority: 1,
    },
    {
      caption: this.dataService.res("Ubt-MeasureDetail-Chart-Progress"),
      dataField: "ProgressPercentage",
      dataType: "number",
      alignment: "left",
      visibleIndex: 8,
      hidingPriority: 4,
      customizeText: (e) => (e.value != null ? `${e.value} %` : "-"),
    },
    {
      caption: this.dataService.res("Ubt-Measure-List-Approval-Request-Status"),
      dataField: "ApprovalStatus",
      dataType: "number",
      alignment: "left",
      visibleIndex: 9,
      hidingPriority: 5,
    },

    {
      type: "buttons",
      caption: "",
      alignment: "left",
      minWidth: 50,
      width: "50px",
      dataField: "",
      visibleIndex: 10,
    },
  ];
  private subscriptions: Subscription[] = [];
  private approvalStatusSet = new Set<string>();
  private groupByColumnIndex = [];
  public noDataText = this.dataService.res("Ubt-No-Data-text");
  public readonly exportFileName =
    this.dataService.res("Ubt-TreeList-Measures") +
    "_" +
    this.datePipe.transform(new Date(), "dd.MM.yyyy");
  protected myMeasure = signal(false);
  public maxScore: number = 36;
  public ratingCount: number = 6;
  public activeTooltip: TooltipType | null = null;

  protected statusTooltipTarget: HTMLElement | null = null;
  protected scoreTooltipTarget: HTMLElement | null = null;

  protected isStatusTooltipVisible = false;
  protected isScoreTooltipVisible = false;
  private approvalStatusLookup: ILookup[] = [];
  protected statusTooltipText = "";
  protected scoreTooltipData: IRating;
  public filters: Filter[] = [];
  protected isArchivedVisible = false;

  private isNavigatToMeasureDetail = false;
  private measureId = "";
  private isFilterDestroyed = false;
  constructor(
    public dataService: DataService,
    private coreDataService: CoreDataService,
    private appService: AppService,
    private measureService: MeasureService,
    private router: Router,
    private datePipe: DatePipe,
    public favoritesService: FavoritesService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef,
    private opathService: BasedRoleOPathService,
    private readonly screenService: ScreenService,
    private resourceManagerService: ResourceManagerService,
    private objectTypeService: ObjectTypeService,
  ) {
    this.APPROVAL_STATUS_UI = ApprovalStatusConfigFactory.createConfig(
      this.dataService,
    );
  }

  public async ngOnInit(): Promise<void> {
    const storedViewType = localStorage.getItem("measureViewType");
    this.viewType =
      storedViewType !== null && +storedViewType === 0
        ? AbcCardViewType.Card
        : AbcCardViewType.Grid;

    this.dataService.floatingButtonConfig();

    this.appService.showLoader(true);
    this.res = await this.resourceManagerService.getResourceSet("ubt-geods");
    this.measurePageTitle = this.dataService.res("Ubt-TreeList-Measures");
    this.appService.measureIds = [];
    this.dataService.checkGridGroupByColumns(
      "measureGrid",
      this.groupByColumnIndex,
    );
    this.subscriptions.push(
      this.dataService
        .prepareStaffMembers()
        .pipe(
          switchMap((staffMembers) => {
            if (Array.isArray(staffMembers) && staffMembers.length > 0) {
              this.dataService.cachedResponsiblesResponse = staffMembers;
              this.measureService.getStuffMemberDataSource(staffMembers);
              this.measureService.getMeasureResponsibleDataSource(staffMembers);

              this.dataService.cachedResponsiblesResponse.sort((a, b) =>
                a.LastName.localeCompare(b.LastName),
              );
            }
            return this.coreDataService
              .executeReadObjectTypeInfo({ ObjectTypeName: ObjectKeys.MEASURE })
              .pipe(
                switchMap((layoutStructure: any) => {
                  this.measureColumns.push(
                    this.coreDataService.createQueryColumn(
                      "Exists(Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id])",
                      "IsFavorite",
                    ),
                    this.coreDataService.createQueryColumn(
                      "Type(BoxDetail)[Box.ParentId = $CurrentUserId AND Box.Designation = 'Favoriten' AND ParentId = ^.Id].Id",
                      "BoxDetailId",
                    ),
                  );
                  layoutStructure.Columns.forEach((column) => {
                    if (this.EXCLUDED_FIELDS.includes(column.Name)) {
                      return;
                    }
                    const existingColumnIndex = this.columnsHeader.findIndex(
                      (c) => c.dataField === column.Name,
                    );

                    if (existingColumnIndex > -1) {
                      this.columnsHeader[existingColumnIndex] = {
                        ...this.columnsHeader[existingColumnIndex],
                        dataType: this.dataService.getDataType(column.DataType),
                        visible: this.VISIBLE_MEASURE_COLUMNS.includes(
                          column.Name,
                        )
                          ? true
                          : false,
                        showInColumnChooser:
                          !this.appService.CONFIG_PROPERTIES.includes(
                            column.Name,
                          )
                            ? true
                            : false,
                        allowReordering: true,
                        alignment: "left",
                        groupIndex: column.Name === "ParentId" ? 0 : undefined,
                        lookup: this.getLookupColumn(column.Name),
                      };
                    } else {
                      this.columnsHeader.push({
                        dataField: column.Name,
                        caption:
                          column.Name === "ParentId"
                            ? this.dataService.res(
                                "Ubt-Measure-List-SubProject",
                              )
                            : this.dataService.res(
                                "Ubt-Measure-List-" + column.DisplayText,
                              ),
                        dataType: this.dataService.getDataType(column.DataType),
                        visibleIndex: this.VISIBLE_MEASURE_COLUMNS.indexOf(
                          column.Name,
                        ),
                        visible: this.VISIBLE_MEASURE_COLUMNS.includes(
                          column.Name,
                        )
                          ? true
                          : false,
                        showInColumnChooser:
                          !this.appService.CONFIG_PROPERTIES.includes(
                            column.Name,
                          )
                            ? true
                            : false,
                        groupIndex: column.Name === "ParentId" ? 0 : undefined,
                        allowReordering: true,
                        alignment: "left",
                        lookup: this.getLookupColumn(column.Name),
                      });
                    }

                    column.Name === "ParentId"
                      ? this.measureColumns.push(
                          this.coreDataService.createQueryColumn(
                            "!.Designation",
                            column.Name,
                            QueryColumnSortOrder.None,
                          ),
                        )
                      : this.measureColumns.push(
                          this.coreDataService.createQueryColumn(
                            column.Name,
                            column.Name,
                            QueryColumnSortOrder.None,
                          ),
                        );
                  });

                  this.currentProfileId = sessionStorage.getItem("profileId");
                  return this.measureService.prepareMeasures(
                    this.measureColumns,
                  );
                }),
              );
          }),
          finalize(() => {
            this.columnsHeader.push({
              caption: this.dataService.res(
                "Ubt-CreateMeasureTask-Collaborators",
              ),
              dataField: "Person",
              visible: false,
              lookup: {
                dataSource: this.executorList,
                displayExpr: "Name",
                valueExpr: "Value",
              },
              showInColumnChooser: true,
              filterOperations: ["contains"],
            });
            this.columnsHeader.forEach((col) => {
              if (col.dataField === "ApprovalStatus") {
                col.lookup = this.getLookupColumn("ApprovalStatus");
              }
            });
          }),
        )
        .subscribe(
          (measures) => {
            const _measuresListDataSource = [];

            if (Array.isArray(measures) && measures.length > 0) {
              measures.forEach((_measure) => {
                let _executorList: String[] = [];
                if (_measure.MeasureResources) {
                  _executorList = _measure.MeasureResources.map(
                    (_resource) => _resource.Person,
                  );
                }
                let LastMeasureProgress: number;
                let ApprovalStatus: string = "";
                if (_measure.LastMeasureProgress) {
                  LastMeasureProgress =
                    _measure?.LastMeasureProgress[0]?.ProgressPercentage;
                  ApprovalStatus = this.getMeasureApprovalRequestStatus(
                    _measure?.LastMeasureProgress[0],
                  );
                  this.approvalStatusSet.add(ApprovalStatus);
                }
                const personSearch = _executorList.join(" | ");
                _measuresListDataSource.push({
                  Id: _measure.Id,
                  Status: _measure.Status,
                  IdRefPersonResponsible: _measure.IdRefPersonResponsible,
                  IdRefPersonSponsor: _measure.IdRefPersonSponsor,
                  IdRefPersonAreaManager: _measure.IdRefPersonAreaManager,
                  Designation: _measure.Designation,
                  StartDate: _measure.StartDate,
                  EndDate: _measure.EndDate,
                  CurrentGrade: _measure.CurrentGrade,
                  Person: _executorList,
                  PersonSearch: personSearch,
                  ApprovalStatus: ApprovalStatus,
                  ProgressPercentage: LastMeasureProgress,
                  ParentId: _measure.ParentId,
                  IsFavorite: _measure.IsFavorite,
                  BoxDetailId: _measure.BoxDetailId,
                  Impact: _measure.Impact,
                  Benefit: _measure.Benefit,
                  Cost: _measure.Cost,
                  Effort: _measure.Effort,
                  CompletionDate: this.removeHtmlTags(_measure.CompletionDate),

                  CurrentState: this.removeHtmlTags(_measure.CurrentState),
                  Concept: this.removeHtmlTags(_measure.Concept),
                  DefenseMeasures: this.removeHtmlTags(
                    _measure.DefenseMeasures,
                  ),
                  Dependencies: this.removeHtmlTags(_measure.Dependencies),
                  ExpectedResults: this.removeHtmlTags(
                    _measure.ExpectedResults,
                  ),
                  Goal: this.removeHtmlTags(_measure.Goal),
                  SeqNr: _measure.SeqNr,
                  TotalScore: _measure.TotalScore,
                });

                if (_executorList.length > 0) {
                  _measure.MeasureResources.forEach((_resource) => {
                    this.updateLookup(this.executorList, _resource.Person);
                  });
                }
              });

              this.measureService.allMeasures = this.formatMeasures(
                _measuresListDataSource,
              );
              this.measures = this.measureService.allMeasures.filter(
                (measure) => measure.Status != "Archived",
              );

              this.buildApprovalStatusLookup();

              this.initializeCardsFilters();
            } else {
              this.notificationService.callNotification({
                message: NotificationMessage.Empty,
                type: ToastType.INFO,
              });
            }
          },
          (error) => {
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
            this.appService.showLoader(false);
            console.error(error);
          },
          () => {
            this.appService.showLoader(false);
          },
        ),
    );

    this.subscriptions.push(
      this.dataService.updateGridData$.subscribe((measure: Measure) => {
        this.getMeasureByIdAndUpdate(this.measureColumns, measure.Id);
      }),
    );
  }
  public get locale(): string {
    return this.appService.locale;
  }
  private buildApprovalStatusLookup(): void {
    this.approvalStatusLookup = Array.from(this.approvalStatusSet)
      .filter(
        (status): status is string =>
          status !== null && status !== undefined && status !== "",
      )
      .map((status) => ({
        Value: status,
        Name: this.dataService.res(
          "Ubt-Measure-List-Approval-Request-" + status,
        ),
      }));
  }

  private getMeasureApprovalRequestStatus(
    lastMeasureProgress: any,
  ): RequestFormattedStatus {
    const lastApprovalRequest = lastMeasureProgress?.ApprovalRequests?.[0];

    if (!lastApprovalRequest) {
      return;
    }

    switch (lastApprovalRequest.Status) {
      case RequestStatus.IN_PROGRESS:
        return this.handleApprovalRequestInProgress(lastApprovalRequest);

      case RequestStatus.REJECTED:
        return this.handleRejectedApprovalRequest(lastApprovalRequest);

      default:
        return;
    }
  }

  private handleRejectedApprovalRequest(
    lastApprovalRequest: any,
  ): RequestFormattedStatus {
    if (lastApprovalRequest.ApprovalSteps?.length > 0) {
      if (lastApprovalRequest.ApprovalSteps[0].SeqNr === 4) {
        return RequestFormattedStatus.WITHDRAWN;
      }

      return RequestFormattedStatus.REJECTED;
    }

    return RequestFormattedStatus.REJECTED;
  }

  private handleApprovalRequestInProgress(
    lastApprovalRequest: any,
  ): RequestFormattedStatus {
    if (lastApprovalRequest.ApprovalSteps?.length > 0) {
      return RequestFormattedStatus.REVIEW_STEERING_COMMITTEE;
    }

    return RequestFormattedStatus.REVIEW_CORE_TEAM;
  }

  public changeViewType(type: AbcCardViewType): void {
    if (type !== this.viewType) {
      this.viewType = type;
      this.isStatusTooltipVisible = false;
      this.isScoreTooltipVisible = false;
      this.activeTooltip = null;
      this.myMeasure.set(!this.myMeasure);
      localStorage.setItem("measureViewType", String(this.viewType));
      if (this.viewType === AbcCardViewType.Grid){
        this.setTheScreenSizeListener();
        this.isFilterDestroyed=true;
      }else
        this.isFilterDestroyed=false;
    }
  }

  ngAfterViewInit(): void {
    if (this.viewType === AbcCardViewType.Grid) {
      this.setTheScreenSizeListener();
    }
  }

  private setTheScreenSizeListener() {
    this.subscriptions.push(
      this.screenService.screen$.subscribe(({ screenSize, isMenuOpened }) => {
        this.screenService.setGridColumnsWidth(
          this.columnsHeader,
          this.measureGrid,
          screenSize,
          isMenuOpened,
          this.getColumnWidth,
        );
      }),
    );
  }

  private initializeCardsFilters(): void {
    this.filters = [
      {
        type: FilterType.datebox,
        label: this.dataService.res("Ubt-Measure-List-StartDate"),
        filterExpr: "StartDate",
        condition: DateFilterCondition.gte,
        showClearButton: true,
      },
      {
        type: FilterType.datebox,
        label: this.dataService.res("Ubt-Measure-List-EndDate"),
        filterExpr: "EndDate",
        condition: DateFilterCondition.lte,
        showClearButton: true,
      },
      {
        type: FilterType.dropdownbox,
        label: this.dataService.res("Ubt-Measure-List-Approval-Request-Status"),
        filterExpr: "ApprovalStatus",
        options: Array.from(this.approvalStatusSet)
          .filter(
            (status): status is string =>
              status !== null && status !== undefined && status !== "",
          )
          .map((status) => ({
            value: status,
            caption: this.dataService.res(
              "Ubt-Measure-List-Approval-Request-" + status,
            ),
          })),
        showClearButton: true,
        filterOptions: true,
        initialValue: [],
      },

      {
        type: FilterType.dropdownbox,
        label: this.dataService.res("Ubt-CreateMeasureTask-Collaborators"),
        filterExpr: "PersonSearch",
        options: this.executorList.map((e) => ({
          caption: e.Name,
          value: e.Value,
        })),
        showClearButton: true,
        filterOptions: true,
        initialValue: [],
      },
      {
        type: FilterType.dropdownbox,
        label: this.dataService.res("Ubt-Measure-List-CurrentGrade"),
        filterExpr: "CurrentGrade",
        options: Array.from(
          new Set(
            this.measures
              .map((m) => m.CurrentGrade)
              .filter((v) => v !== null && v !== undefined),
          ),
        ).map((value) => ({
          value,
          caption: `${value}`,
        })),
        showClearButton: true,
        filterOptions: true,
        initialValue: [],
      },
      {
        type: FilterType.dropdownbox,
        label: this.dataService.res("Ubt-Measure-List-IdRefPersonResponsible"),
        filterExpr: "IdRefPersonResponsible",
        options: Array.from(
          new Set(
            this.measures.map((m) => m.IdRefPersonResponsible).filter(Boolean),
          ),
        ).map((id) => {
          const person = this.dataService.cachedResponsiblesResponse.find(
            (r) => r.Id === id,
          );

          return {
            value: id,
            caption: person
              ? this.dataService.getResponsibleFullName(person)
              : "",
          };
        }),
        showClearButton: true,
        filterOptions: true,
        initialValue: [],
      },

      {
        type: FilterType.dropdownbox,
        label: this.dataService.res("Ubt-Measure-List-Status"),
        filterExpr: "Status",
        options: this.measureService.measureStatus.map((s) => ({
          caption: s.name,
          value: s.name,
        })),
        showClearButton: true,
        filterOptions: true,
        initialValue: [],
      },

      {
        type: FilterType.textbox,
        label: "Search",
        filterExpr: "Search",
        filterByFields: [
          "Designation",
          "TotalScore",
          "CurrentGrade",
          "ParentId",
          "IdRefPersonResponsible",
          "Person",
        ],
        showClearButton: true,
        initialValue: "",
      },
    ];
  }

  public onContentReady(e): void {
    this.appService.measureIds = [];
    const dataSourceFilter = this.measureGrid.instance.getCombinedFilter();
    const dataSource = this.measureGrid.instance.getDataSource();
    if (e) {
      const filteredData = dataSource.items();
      filteredData?.forEach((_filter) => {
        _filter.items?.forEach((_item) => {
          this.appService.measureIds.push(_item.Id);
        });
      });
      this.appService.measureIds = Array.from(
        new Set(this.appService.measureIds),
      );
    }
  }

  public isFavoriteVisible(e) {
    if (e.row?.data.IsFavorite === 1) {
      return true;
    } else {
      return false;
    }
  }

  private updateFavorite(): void {
    if (this.measure["IsFavorite"] === 1) {
      return this.deleteFavorite();
    } else {
      return this.addFavorite();
    }
  }

  public addFavorite(): void {
    const companyName =
      sessionStorage.getItem("companyName") || "Unknown Company";
    const projectName =
      sessionStorage.getItem("projectName") || "Unknown Project";
    const concatenatedString = `${this.measure.ParentId} / ${companyName} / ${projectName} / ${this.measure["Designation"]}`;

    this.favoritesService
      .persistFavoriten(
        GUID.newGUID(),
        this.objectTypeService.getObjectTypesValue(ObjectKeys.MEASURE),
        this.measure.Id,
        concatenatedString,
      )
      .subscribe((data) => {
        this.measuresUpdateState(this.measure, "add", data);
      });
  }

  public deleteFavorite(): void {
    this.favoritesService.deleteFavoriten(this.measure["BoxDetailId"]);
    this.measuresUpdateState(this.measure, "delete");
  }

  public measuresUpdateState(e, state: string, favoriteData?): void {
    let clonedItem = e;
    if (state === "add") {
      clonedItem = { ...e, IsFavorite: 1, BoxDetailId: favoriteData.Id };
      this.notificationService.callNotification({
        message: NotificationMessage.AddToFavorite,
        type: ToastType.SUCCESS,
      });
    } else {
      clonedItem = { ...e, IsFavorite: 0 };
      this.notificationService.callNotification({
        message: NotificationMessage.RemovedFromFavorite,
        type: ToastType.SUCCESS,
      });
    }
    this.measures = this.measures.map((measure)=> measure.Id === e.Id ? clonedItem : measure);
    this.measureService.allMeasures = this.measureService.allMeasures.map((measure)=> measure.Id === e.Id ? clonedItem : measure);
  }

  public setSvgInTableCellWithStyles = (
    htmlCellElement: HTMLElement,
    svg: string,
  ): HTMLElement => {
    htmlCellElement.innerHTML = svg;
    const svgElement = htmlCellElement.querySelector("svg");
    if (svgElement) {
      svgElement.style.position = "relative";
      svgElement.style.marginRight = "24%";
    }
    return htmlCellElement;
  };

  public onCellPrepared(e: CellPreparedEvent): void {
    if (e.rowType !== "data" && e.rowType !== "detailAdaptive") {
      return;
    }

    switch (e.column?.dataField) {
      case "TotalScore":
        this.prepareTotalScoreCell(e);
        break;

      case "Person":
        this.preparePersonCell(e);
        break;
      case "ApprovalStatus":
        this.prepareApprovalStatusCell(e);
        break;
    }

    if (e.column?.type === "buttons") {
      this.prepareButtonCell(e);
    }
  }

  private prepareTotalScoreCell(e: CellPreparedEvent): void {
    if (e.data.TotalScore == null) return;
    const totalScore = e.data.TotalScore ?? 0;

    e.cellElement.innerHTML = "";
    e.cellElement.style.padding = "8px 24px";

    const container = document.createElement("div");
    container.className = "score-cell-container";

    const headerRow = document.createElement("div");
    headerRow.className = "score-header-row";

    const scoreText = document.createElement("strong");
    scoreText.className = "score-text";
    scoreText.style.fontSize = "14px";
    scoreText.textContent = `${totalScore}/${this.maxScore}`;

    headerRow.appendChild(scoreText);

    const progressWrapper = document.createElement("div");
    progressWrapper.className = "score-progress-wrapper";
    progressWrapper.style.display = "flex";
    progressWrapper.style.justifyContent = "center";

    const progressBar = document.createElement("progress");
    progressBar.value = totalScore;
    progressBar.max = this.maxScore;
    progressBar.className = "score-progress";
    progressBar.style.width = "150px";
    progressBar.style.height = "15px";
    progressBar.style.setProperty("accent-color", "var(--primary-color)");
    progressWrapper.appendChild(progressBar);
    container.append(headerRow, progressWrapper);
    e.cellElement.appendChild(container);
  }

  private preparePersonCell(e: CellPreparedEvent): void {
    e.cellElement.innerHTML = e.data.Person.join("<br>");
  }

  private prepareButtonCell(e: CellPreparedEvent): void {
    e.cellElement.style.cursor = "pointer";
    e.cellElement.innerHTML = DefaultIcons.CONTEXTMENU;
  }
  private prepareApprovalStatusCell(e: CellPreparedEvent): void {
    const status: RequestFormattedStatus = e.data.ApprovalStatus;
    const config = this.APPROVAL_STATUS_UI[status];

    if (!config) {
      return;
    }

    e.cellElement.innerHTML = "";
    e.cellElement.style.padding = "8px";

    const container = document.createElement("div");
    container.style.display = "flex";
    container.style.alignItems = "center";
    container.style.gap = "8px";

    const icon = document.createElement("span");

    if (config.emoji) {
      icon.innerText = config.emoji;
      icon.style.fontSize = "16px";
    } else {
      icon.classList.add("dx-icon", `dx-icon-${config.icon}`);
      icon.style.fontSize = "18px";
      icon.style.setProperty(
        "color",
        config.iconColor || "#6b7280",
        "important",
      );
    }

    const badge = document.createElement("div");
    badge.classList.add("approval-status", config.class);

    const text = document.createElement("span");
    text.innerText = config.text;

    badge.appendChild(text);
    container.appendChild(icon);
    container.appendChild(badge);
    e.cellElement.appendChild(container);
  }

  public onCellClick(e) {
    if (e.column?.command === "adaptive") {
      e.event?.stopPropagation();
      return;
    }
    this.measure = e.data;
    if (e.rowType === "data") {
      if (e.column.type === "buttons") {
        e.cellElement.className = "context-menu-icon" + e.rowIndex;
        e.cellElement.innerHTML = this.contextMenu.visible
          ? DefaultIcons.CLOSE
          : DefaultIcons.CONTEXTMENU;

        this.contextMenu.target = ".context-menu-icon" + e.rowIndex;

        this.contextMenuItems[1].visible = this.dataService.hasPermission(
          PermissionContext.Measure,
          ActionType.DELETE,
        );

        this.contextMenuItems[2].text =
          this.measure["IsFavorite"] === 1
            ? this.dataService.res("Ubt-SubProject-Remove-from-favorites")
            : this.dataService.res("Ubt-SubProject-Add-to-favorites");
        this.contextMenu.instance.show();
      } else this.router.navigate(["measureDetail", "measures", e.data.Id]);
    }
  }

  public hoverTooltip(event): void {
    if (this.viewType !== AbcCardViewType.Grid || event.rowType !== "data") {
      return;
    }

    if (event.column.dataField === "TotalScore") {
      this.activeTooltip = "score";
      this.scoreTooltipTarget = event.cellElement;

      if (event.eventType === "mouseover") {
        if (event.data.TotalScore) {
          this.isScoreTooltipVisible = true;
          this.scoreTooltipData = event.data;
        }
      } else {
        this.isScoreTooltipVisible = false;
        this.activeTooltip = null;
      }
    }
  }

  private getColumnWidth = (
    key: string,
    isMenuOpened: boolean,
    largeScreenAddition: number = 0,
  ): string => {
    switch (key) {
      case "Designation":
        const mobileWidth = this.getMobileWidth();

        if (mobileWidth) {
          return `${mobileWidth}px`;
        }

        return isMenuOpened
          ? `${(300 + largeScreenAddition).toString()}px`
          : `${(400 + largeScreenAddition).toString()}px`;

      case "IdRefPersonResponsible":
        return isMenuOpened
          ? `${(150 + largeScreenAddition).toString()}px`
          : `${(250 + largeScreenAddition).toString()}px`;
      case "Status":
        return isMenuOpened
          ? `${(80 + largeScreenAddition).toString()}px`
          : `${(130 + largeScreenAddition).toString()}px`;

      case "EndDate":
        return isMenuOpened
          ? `${(100 + largeScreenAddition).toString()}px`
          : `${(125 + largeScreenAddition).toString()}px`;
      case "CurrentGrade":
        return `${(50 + largeScreenAddition).toString()}px`;
      case "ProgressPercentage":
        return `${(50 + largeScreenAddition).toString()}px`;
      case "ApprovalStatus":
        return `${(75 + largeScreenAddition).toString()}px`;
      case "TotalScore":
        return `${(100 + largeScreenAddition).toString()}px`;
      default:
        return "50px";
    }
  };
  protected onFilterDataSourceChange(measures: Measures[]): void {
    if (this.isFilterDestroyed){
      this.measures=this.measureService.allMeasures;
      this.filterMeasures(this.isArchivedVisible);
    }
    else
      this.measures = measures;
  }
  private getMobileWidth(): number {
    if (window.innerWidth < 400) return 100;
    if (window.innerWidth < 500) return 145;
  }
  public loadMyMeasures(): void {
    this.myMeasure.update((v) => !v);
    const isMyMeasureMode = this.myMeasure();
    let dataToDisplay = this.measures;

    if (isMyMeasureMode) {
      dataToDisplay = this.measures.filter(
        (measure) =>
          measure["IdRefPersonResponsible"] === this.currentProfileId,
      );

      if (!dataToDisplay.length) {
        this.notificationService.callNotification({
          message: NotificationMessage.Empty,
          type: ToastType.INFO,
        });
      }
    }

    this.updateMeasureView(dataToDisplay);
  }
  private updateMeasureView(measures: any[]): void {
    if (this.viewType === AbcCardViewType.Card) {
      this.measureCard.measures = measures;
    } else {
      this.measureGrid.dataSource = measures;
    }
  }

  private getLookupColumn(key: string) {
    const resposibles = this.dataService.cachedResponsiblesResponse;
    if (
      key === "IdRefPersonResponsible" ||
      key === "IdRefPersonConsultant" ||
      key === "IdRefPersonAreaManager" ||
      key === "IdRefPersonSponsor"
    ) {
      return {
        valueExpr: "Id",
        displayExpr: this.dataService.getResponsibleFullName,
        dataSource: resposibles,
      };
    }
    if (key === "ApprovalStatus") {
      return {
        dataSource: this.approvalStatusLookup,
        valueExpr: "Value",
        displayExpr: "Name",
      };
    }

    if (key === "Status") {
      return {
        valueExpr: "name",
        displayExpr: (item: { name: string; value: string }) =>
          this.dataService.res(`Ubt-Measure-List-${item.name}`),
        dataSource: this.measureService.measureStatus,
      };
    }
    if (key === "CurrentGrade") {
      return {
        valueExpr: "name",
        displayExpr: "value",
        dataSource: this.measureService.maturityLevel,
      };
    }
  }

  private getMeasureByIdAndUpdate(columns: QueryColumn[], id: string) {
    const opath = "Id=" + "'" + id + "'";
    this.subscriptions.push(
      this.dataService
        .readObjects(ObjectKeys.MEASURE, columns, opath)
        .subscribe(
          (data) => {
            const formattedMeasures = this.formatMeasures(data);
            this.measures.push(formattedMeasures[0]);
            this.measureGrid.instance.refresh();
            this.notificationService.callNotification({
              message: NotificationMessage.ValidUpdateMessage,
              type: ToastType.SUCCESS,
            });
          },
          (error) => {
            this.notificationService.callNotification({
              message: NotificationMessage.Error,
              type: ToastType.ERROR,
            });
            console.error(error);
          },
        ),
    );
  }

  public onCardClick(measure: any): void {
    this.openMeasureDetails(measure);
  }

  public onFavoriteToggle(event: { event: Event; measure: any }): void {
    this.measure = event.measure;
    this.updateFavorite();
  }

  public onContextMenuOpen(event: { event: Event; measure: any }): void {
    this.measure = event.measure;
    const target = event.event.currentTarget as HTMLElement;
    this.contextMenu.target = target;

    this.contextMenuItems[1].visible = this.dataService.hasPermission(
      PermissionContext.Measure,
      ActionType.DELETE,
    );

    this.contextMenuItems[2].text =
      this.measure["IsFavorite"] === 1
        ? this.dataService.res("Ubt-SubProject-Remove-from-favorites")
        : this.dataService.res("Ubt-SubProject-Add-to-favorites");

    this.contextMenu.instance.show();
  }

  public openMeasureDetails(event?: any): void {
    let measureId: string;

    if (this.viewType === AbcCardViewType.Card) {
      measureId = event?.Id || this.measure?.Id;
    } else {
      measureId = event?.data?.Id || this.measure?.Id;
    }

    if (measureId) {
      this.measureService.currentMeasureIndex =
        this.appService.measureIds.findIndex((item) => item === measureId);
      this.dataService.appService.showMeasureIcon = true;
      this.router.navigate(["measureDetail", "measures", measureId]);
    }
  }

  public openCreationPopup(): void {
    this.measureCreationForm.instance.show();
  }

  public closeCreationPopup(event: {
    isNavigateTomeasureDetail: boolean;
    measureId: string;
  }): void {
    this.measureCreationForm.instance.hide();
    this.isNavigatToMeasureDetail = event.isNavigateTomeasureDetail;
    this.measureId = event.measureId;
  }

  private openConfirmDialog(): void {
    this.confirmDeletePopup.instance.show();
  }
  protected navigateAfterClose(): void {
    if (this.isNavigatToMeasureDetail)
      this.router.navigate(["measureDetail", "measures", this.measureId]);
  }

  public removeMeasure(): void {
    //Delete All Associated Reminders First (ApprovalRequest, ApprovalStep, MeasureTask, MeasureProgress, Measure)
    const requestOPath = `${this.dataService.getCommentParentTypeBase(ObjectKeys.APPROVAL_REQUEST)}.Type(xmtMeasureProgress)[Id= ^.ParentId].ParentId='${this.measure.Id}'`;
    const stepOPath = `${this.dataService.getCommentParentTypeBase(ObjectKeys.APPROVAL_STEP)}.ApprovalRequest.Type(xmtMeasureProgress)[Id= ^.ParentId].ParentId='${this.measure.Id}'`;
    const measureTaskOPath = `${this.dataService.getCommentParentTypeBase(ObjectKeys.MEASURETASK)}.ParentId='${this.measure.Id}'`;
    const measureProgressOPath = `${this.dataService.getCommentParentTypeBase(ObjectKeys.MEASUREPROGRESS)}.ParentId='${this.measure.Id}'`;
    const measureOPath = `${this.dataService.getCommentParentTypeBase(ObjectKeys.MEASURE)}.Id='${this.measure.Id}'`;

    const oPath = `${requestOPath} OR ${stepOPath} OR ${measureTaskOPath} OR ${measureProgressOPath} OR ${measureOPath}`;
    this.dataService
      .readObjects(
        ObjectKeys.REMINDER,
        [this.coreDataService.createQueryColumn("Id")],
        oPath,
      )
      .pipe(
        concatMap((reminders) =>
          Array.isArray(reminders) && reminders.length > 0
            ? this.dataService.persistMultipleObjects(
                ObjectKeys.REMINDER,
                PersistMode.Delete,
                reminders,
              )
            : of(null),
        ),
        concatMap(() =>
          this.dataService.deleteObject(ObjectKeys.MEASURE, this.measure.Id),
        ),
        first(),
      )
      .subscribe({
        next: () => {
          this.notificationService.callNotification({
            message: NotificationMessage.ValidDeleteMessage,
            type: ToastType.SUCCESS,
          });

          this.confirmDeletePopup.instance.hide();
          const index = this.measures.findIndex(
            (item) => item.Id === this.measure.Id,
          );
          this.measures.splice(index, 1);
          this.measureGrid.instance.refresh();
        },
        error: (error) => {
          console.error(error);
          this.notificationService.callNotification({
            message: NotificationMessage.Error,
            type: ToastType.ERROR,
          });
        },
      });
  }

  public abortDelete(): void {
    this.confirmDeletePopup.instance.hide();
  }

  public removeHtmlTags(html: string): string {
    if (!html) return "";
    return html.replace(/<[^>]*>/g, "");
  }

  private updateLookup(type: ILookup[], value: string) {
    if (type.findIndex((element) => element.Value === value) === -1)
      type.push({
        Value: value,
        Name: value,
      });
  }

  public ngOnDestroy(): void {
    this.subscriptions.map((subscription) => subscription.unsubscribe());
  }
  protected setArchivedVisibility(event: ValueChangedEvent): void {
    this.filterMeasures(event.value);
  }
  protected onToolbarPreparing(e: ToolbarPreparingEvent): void {
    e.toolbarOptions.items.unshift({
      location: "after",
      template: "archivedTemplate",
    });
  }
  private formatMeasures(measures: Measures[]): Measures[] {
    return measures.map((measure) => {
      return {
        ...measure,
        Status: this.formatStatus(measure.Status),
      };
    });
  }
  private formatStatus(status: string): string {
    return this.measureService.measureStatus.find((s) => s.value == status)
      ?.name;
  }
  private filterMeasures(value: boolean): void {
    if (value) this.measures = this.measureService.allMeasures;
    else
      this.measures = this.measures.filter(
        (measure) => measure.Status != "Archived",
      );
  }
}

export enum MeasureStatusIcons {
  Done = '<svg height="27px"  id="uuid-04f03c21-7a02-4875-beab-459bdab292ff" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.uuid-3799ce17-e82a-4e82-b177-6f162b86d123{fill:#228B22;}</style></defs><path class="uuid-3799ce17-e82a-4e82-b177-6f162b86d123" d="M60,12c-26.47,0-48,21.53-48,48s21.53,48,48,48,48-21.53,48-48S86.47,12,60,12Zm0,90c-23.16,0-42-18.84-42-42S36.84,18,60,18s42,18.84,42,42-18.84,42-42,42Z"/><polygon class="uuid-3799ce17-e82a-4e82-b177-6f162b86d123" points="50 72.77 38.09 60.87 33.85 65.11 50 81.26 86.15 45.11 81.91 40.86 50 72.77"/></svg>',
  InProgress = '<svg height="27px"  id="uuid-37a4816a-728e-4fd5-83b2-70d733623b3e" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.uuid-45f68346-afdf-4317-98a5-c65e1da98155{fill:	#var(--primary-color);}</style></defs><path class="uuid-45f68346-afdf-4317-98a5-c65e1da98155" d="M84.15,50.93c.24-1.35,.27-2.74,.07-4.13l4.25-1.76v-.04c-.21-1.05-.52-2.08-.94-3.09-.36-.88-.81-1.69-1.28-2.47l-4.21,1.75c-.83-1.19-1.85-2.21-2.98-3.04l1.76-4.25c-1.69-1.08-3.57-1.87-5.53-2.32l-1.75,4.23c-1.41-.24-2.86-.25-4.32,0l-1.75-4.22c-.94,.22-1.87,.49-2.8,.88-.97,.4-1.87,.89-2.73,1.44l1.76,4.24c-1.17,.85-2.18,1.89-2.99,3.06l-4.22-1.75c-1.05,1.71-1.82,3.59-2.24,5.56l4.26,1.76c-.2,1.36-.19,2.75,.06,4.14l-4.21,1.75c.21,.9,.48,1.78,.84,2.66,.42,1.02,.93,1.96,1.51,2.85l4.25-1.76c.82,1.09,1.78,2.03,2.87,2.8l-1.75,4.23c1.71,1.07,3.59,1.84,5.55,2.27l1.76-4.25c1.29,.2,2.63,.21,3.95,0l1.76,4.24c.99-.22,1.99-.51,2.96-.91,.91-.38,1.77-.84,2.59-1.35l-1.75-4.22c1.11-.8,2.07-1.74,2.87-2.8l4.26,1.76c1.1-1.69,1.88-3.56,2.35-5.52l-4.22-1.75Zm-10.11,4.13c-3.56,1.47-7.66-.23-9.13-3.78s.23-7.66,3.78-9.13,7.66,.23,9.13,3.78-.23,7.66-3.78,9.13Z"/><path class="uuid-45f68346-afdf-4317-98a5-c65e1da98155" d="M108,60c0-26.47-21.53-48-48-48-8.46,0-16.41,2.21-23.32,6.07l4.23,4.54c5.73-2.94,12.22-4.61,19.09-4.61,23.16,0,42,18.84,42,42,0,8.97-2.84,17.27-7.64,24.1l-4.51-4.91-2.6,16.45,16.61-1.21-5.35-5.82c5.96-8,9.5-17.89,9.5-28.6Z"/><path class="uuid-45f68346-afdf-4317-98a5-c65e1da98155" d="M60,102c-1.33,0-2.64-.07-3.93-.19,.43-.8,.82-1.62,1.17-2.46,1.04-2.5,1.69-5.1,1.98-7.72h7.02c.17-1.98,.18-3.99,0-6h-7.03c-.29-2.62-.94-5.21-1.98-7.72-1.05-2.53-2.43-4.82-4.07-6.84l4.98-4.98c-1.3-1.55-2.73-2.96-4.25-4.24l-4.98,4.98c-4.17-3.35-9.24-5.45-14.56-6.03v-7.04c-1.98-.17-3.99-.18-6,0v7.04c-2.59,.28-5.19,.92-7.72,1.97-.85,.35-1.67,.75-2.46,1.17-.12-1.30-.19-2.61-.19-3.94,0-8.97,2.83-17.28,7.64-24.1l4.52,4.92,2.61-16.45-16.61,1.21,5.35,5.82c-5.96,8-9.5,17.89-9.5,28.61,0,26.47,21.53,48,48,48,8.46,0,16.41-2.21,23.32-6.07l-4.23-4.54c-5.73,2.94-12.22,4.61-19.09,4.61Zm-40.73-31.73c1.14-.75,2.36-1.42,3.68-1.96,2.74-1.14,5.59-1.67,8.39-1.67,8.64,0,16.85,5.12,20.35,13.58,2.25,5.43,2.25,11.41,0,16.84-.54,1.30-1.21,2.52-1.97,3.67-14.92-3.77-26.68-15.53-30.45-30.45Z"/></svg>',
  Offen = '<svg  height="27px"  id="uuid-c532442b-353e-4cb6-89eb-f2551873f941" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 120 120"><defs><style>.uuid-9fad3273-f016-4e9d-a232-5afba1bcffac{fill:	#FF6347;}</style></defs><path class="uuid-9fad3273-f016-4e9d-a232-5afba1bcffac" d="M63.03,63l-15.42,15.42,4.24,4.24,22.66-22.66-22.66-22.66-4.24,4.24,15.42,15.42H12.1c-.06,.99-.1,1.99-.1,3s.04,2.01,.1,3H63.03Z"/><path class="uuid-9fad3273-f016-4e9d-a232-5afba1bcffac" d="M60,12c-21.38,0-39.53,14.05-45.72,33.39h6.35c5.94-15.98,21.34-27.39,39.37-27.39,23.16,0,42,18.84,42,42s-18.84,42-42,42c-18.02,0-33.42-11.42-39.37-27.39h-6.35c6.19,19.35,24.34,33.39,45.72,33.39,26.47,0,48-21.53,48-48S86.47,12,60,12Z"/></svg>',
}

export interface ILookup {
  Value: string;
  Name: string;
}

export class Measures {
  Id: string;
  Status: string;
  IdRefPersonResponsible: string;
  IdRefPersonSponsor: string;
  IdRefPersonAreaManager: string;
  Designation: string;
  StartDate: string;
  EndDate: string;
  CurrentGrade: string;
  Person: string[];
  ParentId: string;
  constructor(data) {
    Object.assign(this, data);
  }
}
